<template>
  <div class="ajout" >
    <b-form @submit="onSubmitDL" class="d-block forms">
      <h2 class="bold">{{$t($route.meta.title.replace(' - Ooftop','').split(' - ')[1])}}</h2>
      <p class="hight">{{$t("Nouvelle demande")}}</p>
      <div class="container">
        <div class="row">
            <div class="col-md-9 bg-blue">
              <h3 class="bold mb-3">{{$t('Choix de la prestation')}}</h3>
              <b-form-group id="prestation-group" label-for="type_formulaire" class=" mb-5">
                <b-form-radio-group buttons v-model="prestation" name="prestation" :options="this.choix_prestation" @change="get_data()"></b-form-radio-group>
              </b-form-group>
              <div class="pp mt-3" v-if="hasPP">
                <h3 class="bold  mb-3">{{$t('Personne(s) physique(s)')}}</h3>
                <div class="container">
                  <div class="row p-3">
                    <div v-for="(form,index) in forms.pp" :key="index" class="col-md-12 mb-2 blueBorder">
                      <div class="col-md-12 p-4">
                        <h4>{{$t('Personne physique')}} {{index+1}} <a href="javascript:void(0)" @click="delete_form(forms.pp,index)">{{$t("supprimer")}}</a></h4>
                        <div class="row">
                          <b-form-group label-for="civilite" class="light size-part size-part-2 col-md-6">
                            <template slot="label">{{$t('Civilité')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-radio-group buttons id="civilite" :options="civilites" v-model='form.civilite'></b-form-radio-group>
                          </b-form-group>
                          <b-form-group label-for="nom" class="col-md-6" v-if="form.civilite==='M'">
                            <template slot="label">{{$t('Nom')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="nom" class="alphaCheck" v-model='form.nom' required maxlength="50"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="nom_jf" class="col-md-6" v-if="form.civilite==='MME'">
                            <template slot="label">{{$t('Nom de jeune fille')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="nom_jf" class="alphaCheck" v-model='form.nom_jf' required maxlength="50"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="prenom" class="col-md-6">
                            <template slot="label">{{$t('Prénom')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="prenom" class="alphaCheck" v-model='form.prenom' required maxlength="50" @blur="form.prenom=remove_accents(form.prenom);"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="prenom" class="col-md-6">
                            <template slot="label">{{$t('Prénom')}} 2 <i>(conseillé)</i></template>
                            <b-form-input id="prenom2" class="alphaCheck" v-model='form.prenom2' maxlength="50" @blur="form.prenom2=remove_accents(form.prenom2);"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="date_naissance" class="date_naissance col-md-6">
                            <template slot="label">{{$t('Date de naissance')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="date_naissance" type="text" v-model='form.date_naissance' required v-mask="'##/##/####'" placeholder="jj/mm/aaaa"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="pays_naissance" class="col-md-6">
                            <template slot="label">{{$t('Pays de naissance')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-select id="pays_naissance" :options="pays" class="form-control" v-model='form.pays_naissance' required @change="change_pays_naissance(form)"></b-form-select>
                          </b-form-group>
                          <b-form-group label-for="cp_naissance" class="cpv cp col-md-6">
                            <template slot="label">{{$t('Code postal de naissance')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <autocomplete v-if="form.cp_naissance===''" :placeholder="$t('Votre code postal')" :source="getDataCPN" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCPN($event,form)"></autocomplete>
                            <b-form-input v-if="form.cp_naissance" id="cp_naissance" v-model='form.cp_naissance' required @focus="resetcp(form)"></b-form-input>
                            <b-form-input id="ci_naissance" v-model='form.ci_naissance' required class="hidden"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="ville_naissance" class="cpv ville col-md-6">
                            <template slot="label">{{$t('Ville de naissance')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <autocomplete v-if="form.ville_naissance==='' && form.pays_naissance==='99100'" :placeholder="$t('Votre ville')" :source="getDataCPNV" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCPN($event,form)"></autocomplete>
                            <b-form-input v-if="form.ville_naissance || form.pays_naissance!=='99100'" id="ville_naissance" v-model='form.ville_naissance' required @focus="resetcp(form)"></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                      <a href="javascript:void(0)" class="ajouterForm btn btn-gold" @click="ajouter_form(forms.pp,'pp',1)"><i>+</i> <span>{{$t("Ajouter une personne physique")}}</span></a>
                  </div>
                </div>
              </div>
              <div class="pm mt-3" v-if="hasPM">
                <h3 class="p-2 bold">{{$t('Personne(s) morale(s)')}}</h3>
                <div class="container">
                  <div class="row p-3">
                    <div v-for="(form,index) in forms.pm" :key="index" class="col-md-12 mb-2 blueBorder">
                      <div class="col-md-12 p-4">
                        <h4>{{$t('Personne morale')}} {{index+1}} <a href="javascript:void(0)" @click="delete_form(forms.pm,index)">{{$t("supprimer")}}</a></h4>
                        <b-form-group label-for="type">
                          <template slot="label">Type <sup>{{$t("(champ obligatoire)")}}</sup></template>
                          <b-form-select id="type" required :options="type_ste" class="form-control" v-model='form.type'></b-form-select>
                        </b-form-group>
                        <b-form-group label-for="siren" v-if="form.type==='I'">
                          <template slot="label">{{$t('SIREN')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                          <autocomplete v-if="form.siren.length<9" :placeholder="$t('Votre siren')" :source="getDataSIREN" input-class="form-control numCheck" results-property="data" :resultsFormatter="resultDataSIREN" :results-display="formattedDataSIREN" @selected="addDataSIREN($event,form)"></autocomplete>
                          <b-form-input v-if="form.siren.length>8" id="siren" v-model='form.siren' required></b-form-input>
                        </b-form-group>
                        <div class="row" v-if="form.type!=='I' || form.siren.length>8 ">
                          <b-form-group label-for="denomination" class="col-md-12">
                            <template slot="label">{{$t('Dénomination')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="denomination" v-model='form.denomination' required></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="adresse" class="col-md-12">
                            <template slot="label">{{$t('Numéro / voie')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="adresse" v-model='form.adresse' required></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="code_postal" class="col-md-6">
                            <template slot="label">{{$t('Code postal')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="code_postal" v-model='form.code_postal' required></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="ville" class="col-md-6">
                            <template slot="label">{{$t('Ville')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="ville" v-model='form.ville' required></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="code_postal_rcs" class="col-md-6">
                            <template slot="label">{{$t('Code postal')}} RCS <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="code_postal_rcs" v-model='form.code_postal_rcs' required></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="ville_rcs" class="col-md-6">
                            <template slot="label">{{$t('Ville')}} RCS <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="ville_rcs" v-model='form.ville_rcs' required></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="categorie_juridique" class="col-md-6">
                            <template slot="label">{{$t('Catégorie Juridique')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-select id="categorie_juridique" :options="categorie_juridique" class="form-control" v-model='form.categorie_juridique' required></b-form-select>
                          </b-form-group>
                          <b-form-group label-for="pays" class="col-md-6">
                            <template slot="label">{{$t('Pays')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-select id="pays" :options="pays" class="form-control" v-model='form.pays' required></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                      <a href="javascript:void(0)" class="ajouterForm btn btn-gold" @click="ajouter_form(forms.pm,'pm',1)"><i>+</i> <span>{{$t('Ajouter une personne morale')}}</span></a>
                  </div>
                </div>
              </div>
              <div class="zn mt-3" v-if="hasZN && forms.im.length==0 && (forms.pm.length+forms.pp.length)>0">
                <h3 class="p-2 bold">{{$t('Zone(s) géographique(s)')}}</h3>
                <div class="container">
                  <div class="row p-3">
                    <div v-for="(form,index) in forms.zn" :key="index" class="col-md-12 mb-2 blueBorder">
                      <div class="col-md-12 p-4">
                        <h4>{{$t('Zone')}} {{index+1}} <a href="javascript:void(0)" @click="delete_form(forms.zn,index)">{{$t('supprimer')}}</a></h4>
                        <b-form-group label-for="type">
                          <template slot="label">Type <sup>{{$t("(champ obligatoire)")}}</sup></template>
                          <b-form-select id="type" required :options="type_zone" class="form-control" v-model='form.type'></b-form-select>
                        </b-form-group>
                        <div class="row" v-if="form.type=='C'">
                          <b-form-group label-for="code_postal" class="cpv cp col-md-6">
                            <template slot="label">{{$t('Code postal')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <autocomplete v-if="form.code_postal===''" :placeholder="$t('Votre code postal')" :source="getDataCPN" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,form)"></autocomplete>
                            <b-form-input v-if="form.code_postal" id="code_postal" v-model='form.code_postal' required @focus="form.code_insee='';form.code_postal='';form.ville='';"></b-form-input>
                            <b-form-input id="code_insee" v-model='form.code_insee' required class="hidden"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="ville" class="cpv ville col-md-6">
                            <template slot="label">{{$t('Ville')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                              <autocomplete v-if="form.ville===''" :placeholder="$t('Votre ville')" :source="getDataCPNV" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,form)"></autocomplete>
                              <b-form-input v-if="form.ville" id="ville" v-model='form.ville' required @focus="form.code_insee='';form.code_postal='';form.ville='';"></b-form-input>
                          </b-form-group>
                        </div>
                        <b-form-group label-for="region" v-if="form.type=='R'">
                          <template slot="label">Région <sup>{{$t("(champ obligatoire)")}}</sup></template>
                          <b-form-select id="region" :options="regions" class="form-control" v-model='form.region' required @change="cpc"></b-form-select>
                        </b-form-group>
                        <b-form-group label-for="departement" v-if="form.type=='D'">
                          <template slot="label">Département <sup>{{$t("(champ obligatoire)")}}</sup></template>
                          <b-form-select id="departement" :options="departements" class="form-control" v-model='form.departement' required @change="cpc"></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                      <a href="javascript:void(0)" class="ajouterForm btn btn-gold" @click="ajouter_form(forms.zn,'zn',1)"><i>+</i> <span>{{$t('Ajouter une zone')}}</span></a>
                  </div>
                </div>
              </div>
              <div class="im mt-3" v-if="hasIM && forms.zn.length==0">
                <h3 class="p-2 bold">{{$t('Immeuble')}}(s)</h3>
                <div class="container">
                  <div class="row p-3">
                    <div v-for="(form,index) in forms.im" :key="index" class="col-md-12 mb-2 blueBorder">
                      <div class="col-md-12 p-4">
                        <h4>{{$t('Immeuble')}} {{index+1}} <a href="javascript:void(0)" @click="delete_form(forms.im,index)">{{$t('supprimer')}}</a></h4>
                        <b-form-group label-for="ref_cad" class="withLink">
                            <template slot="label">{{$t('Référence(s) cadastrale(s)')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <a href="javascript:void(0)" @click="form.ajouter_plage={de:{prefixe:'',section:'',parcelle:''},a:{prefixe:'',section:'',parcelle:''}}">{{$t('Ajouter une plage')}}</a>
                            <div class="ajouterPlage mb-3" v-if="form.ajouter_plage">
                              <b-form-group label="Début">
                                <div class="row">
                                  <div class="col-md-4 pr-1"><b-form-input v-model='form.ajouter_plage.de.prefixe' class="numCheck" :placeholder="$t('Préfixe')+' (ex : 000)'"></b-form-input></div>
                                  <div class="col-md-4 pr-1"><b-form-input v-model='form.ajouter_plage.de.section' class="alphaNumCheck" required :placeholder="$t('Section')+' * (ex : A, AV) *'"></b-form-input></div>
                                  <div class="col-md-4 pr-1"><b-form-input v-model='form.ajouter_plage.de.parcelle' class="numCheck" required :placeholder="$t('Parcelle')+' * (ex : 250, 10..) *'"></b-form-input></div>
                                </div>
                              </b-form-group>
                              <b-form-group label="A">
                                <div class="row">
                                  <div class="col-md-4 pr-1"><b-form-input v-model='form.ajouter_plage.a.prefixe' class="numCheck" :placeholder="$t('Prefixe')+' (ex : 000)'"></b-form-input></div>
                                  <div class="col-md-4 pr-1"><b-form-input v-model='form.ajouter_plage.a.section' class="alphaNumCheck" required :placeholder="$t('Section')+' * (ex : A, AV) *'"></b-form-input></div>
                                  <div class="col-md-4 pr-1"><b-form-input v-model='form.ajouter_plage.a.parcelle' class="numCheck" required :placeholder="$t('Parcelle')+' * (ex : 250, 10..) *'"></b-form-input></div>
                                </div>
                              </b-form-group>
                              <a href="javascript:void(0)" @click="ajouter_plage(form)" class="btn btn-gold btn-sm">Ajouter la plage</a>
                            </div>
                            <div class="refCads row mb-1" v-for="(ref_cad,irc) in form.ref_cad" :key="irc">
                              <div class="col-md-10">
                                <div class="row">
                                  <div class="col-md-4 pr-1"><b-form-input v-model='ref_cad.prefixe' class="numCheck" :placeholder="$t('Prefixe')+' (ex : 000)'" @blur="cpc"></b-form-input></div>
                                  <div class="col-md-4 pr-1"><b-form-input v-model='ref_cad.section' class="alphaNumCheck" required :placeholder="$t('Section')+' * (ex : A, AV) *'" @blur="cpc"></b-form-input></div>
                                  <div class="col-md-4 pr-1"><b-form-input v-model='ref_cad.parcelle' class="numCheck" required :placeholder="$t('Parcelle')+' * (ex : 250, 10..) *'" @blur="cpc"></b-form-input></div>
                                </div>
                              </div>
                              <div class="col-md-2 moreLess">
                                <a href="javascript:void(0)" @click="ajouter_form(form.ref_cad,'ref_cad',0)">+</a>
                                <a href="javascript:void(0)" @click="delete_form(form.ref_cad,irc)" v-if="irc>0">-</a>
                              </div>
                            </div>
                        </b-form-group>
                        <b-form-group :label="$t('Coproprièté')" label-for="copropriete">
                          <b-form-select id="copropriete" :options="copropriete" class="form-control" v-model='form.copropriete'></b-form-select>
                        </b-form-group>
                        <b-form-group :label="$t('N° de Lot(s) - de copropriété')" label-for="copropriete_lot" v-if="form.copropriete">
                          <b-form-input id="copropriete_lot" v-model='form.copropriete_lot.libre' required :placeholder="$t('Saisie libre')" @blur="cpc" class="libre"></b-form-input>
                          <div class="coproprieteLots row mt-1"  v-for="(copropriete_lot,ircl) in form.copropriete_lot.plage" :key="ircl">
                            <div class="col-md-5 pr-1"><b-form-input v-model='copropriete_lot.de' required :placeholder="$t('De')+' :'" @blur="cpc" class="de"></b-form-input></div>
                            <div class="col-md-5 pr-1"><b-form-input v-model='copropriete_lot.a' required :placeholder="$t('a')+' :'" @blur="cpc" class="a"></b-form-input></div>
                            <div class="col-md-2 moreLess">
                              <a href="javascript:void(0)" @click="ajouter_form(form.copropriete_lot.plage,'lot_plage',0)">+</a>
                              <a href="javascript:void(0)" @click="delete_form(form.copropriete_lot.plage,ircl)" v-if="ircl>0">-</a>
                            </div>
                          </div>
                        </b-form-group>
                        <b-form-group :label="$t('N° de Lot(s) - Volume')" label-for="copropriete_volume" v-if="form.copropriete">
                          <b-form-input id="copropriete_volume" v-model='form.copropriete_volume.libre' required :placeholder="$t('Saisie libre')" @blur="cpc" class="libre"></b-form-input>
                          <div class="coproprieteVolumes row mt-1"  v-for="(copropriete_volume,ircv) in form.copropriete_volume.plage" :key="ircv">
                            <div class="col-md-5 pr-1"><b-form-input v-model='copropriete_volume.de' required :placeholder="$t('De')+' :'" @blur="cpc" class="de"></b-form-input></div>
                            <div class="col-md-5 pr-1"><b-form-input v-model='copropriete_volume.a' required :placeholder="$t('a')+' :'" @blur="cpc" class="a"></b-form-input></div>
                            <div class="col-md-2 moreLess">
                              <a href="javascript:void(0)" @click="ajouter_form(form.copropriete_volume.plage,'lot_plage',0)">+</a>
                              <a href="javascript:void(0)" @click="delete_form(form.copropriete_volume.plage,ircv)" v-if="ircv>0">-</a>
                            </div>
                          </div>
                        </b-form-group>
                        <b-form-group :label="$t('Numéro / voie')" label-for="adresse">
                            <b-form-input id="adresse" v-model='form.adresse' maxlength="50"></b-form-input>
                        </b-form-group>
                        <div class="row">
                          <b-form-group label-for="code_postal" class="cpv cp col-md-6">
                            <template slot="label">{{$t('Code postal')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <autocomplete v-if="form.code_postal===''" :placeholder="$t('Votre code postal')" :source="getDataCPN" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,form)"></autocomplete>
                            <b-form-input v-if="form.code_postal" id="code_postal" v-model='form.code_postal' required @focus="form.code_insee='';form.code_postal='';form.ville='';"></b-form-input>
                            <b-form-input id="code_insee" v-model='form.code_insee' required class="hidden"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="ville" class="cpv ville col-md-6">
                            <template slot="label">{{$t('Ville')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <autocomplete v-if="form.ville===''" :placeholder="$t('Votre ville')" :source="getDataCPNV" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,form)"></autocomplete>
                            <b-form-input v-if="form.ville" id="ville" v-model='form.ville' required @focus="form.code_insee='';form.code_postal='';form.ville='';"></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                      <a href="javascript:void(0)" class="ajouterForm btn btn-gold" @click="ajouter_form(forms.im,'im',1)"><i>+</i> <span>{{$t('Ajouter un immeuble')}}</span></a>
                  </div>
                </div>
              </div>
              <div class="docs mt-3" v-if="hasDOCS && prestation!=''">
                <h3 class="p-2 bold">Documents(s)</h3>
                <div class="container">
                  <div class="row p-3">
                    <div v-for="(form,index) in forms.docs" :key="index" class="col-md-12 mb-2 blueBorder">
                      <div class="col-md-12 p-4">
                        <h4>Document {{index+1}} <a href="javascript:void(0)" @click="delete_form(forms.docs,index)">{{$t('supprimer')}}</a></h4>
                        <b-form-group label-for="type">
                          <template slot="label">Type <sup>{{$t("(champ obligatoire)")}}</sup></template>
                          <b-form-select id="type" required :options="type_documents" class="form-control" v-model='form.type'></b-form-select>
                        </b-form-group>
                        <div class="row">
                          <b-form-group label-for="ref_enliassement" class="col-md-6">
                            <template slot="label">{{$t('Référence d’enliassement')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="ref_enliassement" v-model='form.ref_enliassement' required @blur="cpc" maxlength="20"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="date_publication" class="date_publication col-md-6">
                            <template slot="label">{{$t('Date de la publication')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <b-form-input id="date_publication" type="text" v-model='form.date_publication' required @blur="cpc" v-mask="'##/##/####'"></b-form-input>
                          </b-form-group>
                          <b-form-group label-for="code_postal" class="cpv cp col-md-6">
                            <template slot="label">{{$t('Code postal du bien immobilier')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <autocomplete v-if="form.code_postal===''" :placeholder="$t('Votre code postal')" :source="getDataCPN" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,form)"></autocomplete>
                            <b-form-input v-if="form.code_postal" id="code_postal" v-model='form.code_postal' required @focus="form.code_insee='';form.code_postal='';form.ville='';"></b-form-input>
                            <b-form-input id="code_insee" v-model='form.code_insee' required class="hidden"></b-form-input>
                            <p><small>{{$t('Il s’agit du code postal du bien immobilier concerné par le document demandé')}}.</small></p>
                          </b-form-group>
                          <b-form-group label-for="ville" class="cpv ville col-md-6">
                            <template slot="label">{{$t('Ville du bien immobilier')}} <sup>{{$t("(champ obligatoire)")}}</sup></template>
                            <autocomplete v-if="form.ville===''" :placeholder="$t('Votre ville')" :source="getDataCPNV" input-class="form-control" results-property="data" :resultsFormatter="resultDataCPN" :results-display="formattedDataCPN" @selected="addDataCP($event,form)"></autocomplete>
                            <b-form-input v-if="form.ville" id="ville" v-model='form.ville' required @focus="form.code_insee='';form.code_postal='';form.ville='';"></b-form-input>
                            <p><small>{{$t('Il s’agit de la ville du bien immobilier concerné par le document demandé')}}.</small></p>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                      <a href="javascript:void(0)" class="ajouterForm btn btn-gold" @click="ajouter_form(forms.docs,'docs',1)"><i>+</i> <span>{{$t('Ajouter un document')}}</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="bg-blue">
                <DynField name="reference_client" v-model="forms.reference"></DynField>
                <div class="options mt-3" v-if="hasZN && (forms.im.length+forms.pm.length+forms.pp.length)>0">
                  <h3 class="p-2 bold">Options</h3>
                  <div>
                    <b-form-group label="Fiche d'analyse" label-for="fiche_analyse">
                      <b-form-radio-group id="fiche_analyse" v-model="forms.options.fiche_analyse" :options="type_fa" name="fiche_analyse" v-on:change="cpc();forms.options.options=[];"></b-form-radio-group>
                    </b-form-group>
                    <b-form-group label="Options" label-for="options" v-if="forms.options.fiche_analyse">
                      <b-form-checkbox-group v-if="forms.im.length===0 && !includes(forms.options.options,'OOF_FICHEA')" v-model="forms.options.options" :options="type_options" name="options-options" stacked v-on:change="cpc"></b-form-checkbox-group>
                      <b-form-checkbox-group v-if="forms.im.length===0 && includes(forms.options.options,'OOF_FICHEA')" v-model="forms.options.options" :options="type_options_v" name="options-options" stacked v-on:change="cpc"></b-form-checkbox-group>
                      <b-form-checkbox-group v-if="forms.im.length>0" v-model="forms.options.options" :options="type_options_im" name="options-options" stacked v-on:change="cpc"></b-form-checkbox-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="panier mt-3" v-if="forms.docs.length>0 || forms.im.length>0 || (forms.zn.length>0 && (forms.pm.length+forms.pp.length)>0)">
                  <p class="bigText2"><b>{{$t('Total prestation')}} : {{ parseInt(panier.total.prix).toFixed(2) }} {{$t("€")}}</b></p>
                  <p class="bigText2"><b>{{$t('Total débours')}} : {{ parseInt(panier.total.debours).toFixed(2) }} {{$t("€")}}</b></p>
                </div>
                <br/>
                <b-form-checkbox id="cgv" v-model="cgv_ok" value="1" unchecked-value="0"> {{$t('Je reconnais avoir pris connaissance des')}} <a href="javascript:void(0)" @click="$bvModal.show('modal-cgu')"> {{$t('Conditions Générales de Vente')}}</a> {{$t('et les accepter sans réserve')}}.</b-form-checkbox><br/>
                <p>
                  <b-button class="btn-gold" type="button" @click="onSubmitDL" :disabled="loading" v-if="forms.docs.length>0 || forms.im.length>0 || (forms.zn.length>0 && (forms.pm.length+forms.pp.length)>0)"><span v-if="loading">{{$t('Enregistrement')}} ...</span><span v-if="!loading">{{$t('Commander')}}</span></b-button>
                  <b-button class="btn-gold disabled" type="button" @click="alertEF" v-else>{{$t('Commander')}}</b-button>
                </p>
              </div>
            </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import axios from "axios";
  import VueInputMask from 'v-mask';
  import DynField from '@/components/Fields/DynField'
  export default {
      components: { VueInputMask,DynField },
      data() {
        return {
          prestation: '',
          hasPP:true,
          hasPM:true,
          hasIM:true,
          hasDOCS:true,
          hasZN:true,
          yesno:[
            {value:"0",text:this.$i18n.t("Non")},
            {value:"1",text:this.$i18n.t("Oui")}
          ],
          civilites:[
            {value:"M",text:this.$i18n.t("Monsieur")},
            {value:"MME",text:this.$i18n.t("Madame")}
          ],
          type_ste:[
            {value:"I",text:this.$i18n.t("SIREN")},
            {value:"E",text:this.$i18n.t("En cours d'immatriculation")},
            {value:"N",text:this.$i18n.t("Non immatriculée")}
          ],
          categorie_juridique:[],
          copropriete:[
            {value:0,text:this.$i18n.t("Non")},
            {value:1,text:this.$i18n.t("Oui")}
          ],
          type_zone:[
            {value:'C',text:"Commune"},
            {value:'R',text:"Région"},
            {value:'D',text:"Département"}
          ],
          type_documents:[
            {text:this.$i18n.t("Titre de proprièté"),value:"OOF_TPRO"},
            {text:this.$i18n.t("Règlement de copropriété (RCP) / Etat descriptif de vision (EDD) / Modification RCP-EDD"),value:"OOF_RCPEDD"},
            {text:this.$i18n.t("Privilège de prêteur de deniers"),value:"OOF_PPD"},
            {text:this.$i18n.t("Privilège de vendeur"),value:"OOF_PVEN"},
            {text:this.$i18n.t("Privilège de copartageant"),value:"OOF_PCO"},
            {text:this.$i18n.t("Hypothèque conventionnelle"),value:"OOF_HCON"},
            {text:this.$i18n.t("Hypothèque judiciaire"),value:"OOF_HJU"},
            {text:this.$i18n.t("Hypothèque judiciaire provisoire"),value:"OOF_HJUP"},
            {text:this.$i18n.t("Hypothèque judiciaire définitive"),value:"OOF_HJUD"},
            {text:this.$i18n.t("Hypothèque légale"),value:"OOF_HL"},
            {text:this.$i18n.t("Saisie (ordonnance)"),value:"OOF_SAISIEC"},
            {text:this.$i18n.t("Saisie pénale"),value:"OOF_SAISIEP"},
          ],
          type_fa:[{value:1,text:this.$i18n.t("Oui")},{value:0,text:this.$i18n.t("Non")}],
          type_options:[{value:"OOF_FICHEA",text:this.$i18n.t("Analyse du patrimoine restant")},{value:"OOF_FICHEP",text:this.$i18n.t("Analyse du patrimoine vendu")}],
          type_options_v:[{value:"OOF_FICHEA",text:this.$i18n.t("Analyse du patrimoine restant")},{value:"OOF_FICHEP",text:this.$i18n.t("Analyse du patrimoine vendu")},{value:"OOF_VALO",text:this.$i18n.t("Valorisation statistique du bien")}],
          type_options_im:[{value:"OOF_VALO",text:this.$i18n.t("Valorisation statistique du bien")}],
          choix_prestation:[
              {text:this.$i18n.t("État hypothécaire"),value:"OOF_EH"},
              {text:this.$i18n.t("Copie de documents"),value:"OOF_CD"},
              {text:this.$i18n.t("Matrice cadastrale"),value:"OOF_MC"},
          ],
          pays:[],
          regions:[],
          departements:[],
          infos_cli:{nom:'',societe:[],partner:[]},
          cgv_ok:0,
          forms:{
            reference:'',
            partner:{user_for:'',entite:'',demande_email:1,rapport_email:1,commentaire:''},
            pp:[],
            pm:[],
            im:[],
            zn:[],
            docs:[],
            options:{fiche_analyse:1,options:["OOF_FICHEA"]}
          },
          panier:{panier:[],nb:[],total:{prix:0,debours:0}},
          loading:false,
        }
      },
      watch: {
      },
      created(){
        this.get_infos_cli();
      },
      mounted() {
        this.get_pays();
        this.get_regions();
        this.get_departements();
        this.get_categories_juridiques();
        this.check_price('DOCL',this.forms);
        this.get_data();
      },
      methods: {
        get_data() {
          var p=this;
          window.setTimeout(function(){
            p.get_label_presta(p.prestation);
            if(p.prestation=="OOF_EH"){
              p.hasDOCS=false;
              p.hasPP=true;
              p.hasPM=true;
              p.hasIM=true;
              p.hasZN=true;
              p.type_zone=[{value:'C',text:"Commune"},{value:'R',text:"Région"},{value:'D',text:"Département"}];
            }else{
              p.type_zone=[{value:'C',text:"Commune"}];
              if(p.prestation=="OOF_MC"){
                p.hasDOCS=false;
                p.hasPP=true;
                p.hasPM=true;
                p.hasIM=false;
                p.hasZN=true;
              }else{
                p.hasPP=false;
                p.hasPM=false;
                p.hasIM=false;
                p.hasZN=false;
                p.hasDOCS=true;
              }
            }
          },500)
        },
        onSubmitDL(evt) {
            evt.preventDefault()
            var error=0;
            error=this.check_form(".ajout form");
            if(this.cgv_ok!=1){this.infosModal('warning',this.$i18n.t("Merci d'accepter les conditions générales de vente."),false,'Informations');}
            else if(this.forms.reference==""){this.infosModal('warning',this.$i18n.t("Merci de remplir la référence du dossier."),false,'Informations');}
            else if(error>0)this.infosModal('warning',this.$i18n.t('Merci de bien vouloir remplir tous les champs suivants correctement avant de valider votre demande')+' : <ul>'+this.errorTxt+'</ul>',false,this.$i18n.t('Champs incomplets'));
            else{
              var p=this;
              p.loading=true;
              let formData = new FormData();
              formData.append('datas', JSON.stringify(p.forms));
              axios.post(p.$apiUrl+"demandes/submit/DOCL?lang="+this.$i18n.locale+"&auth="+JSON.stringify(p.auth_header()),formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(function(response){
                if(response.data.error=='notlogged'){
                  p.logout();
                  p.$router.push({ path: '/' });
                }
                else{
                  if (response.data.success) {
                    p.infosModal('success',response.data.success,'documents_legaux','Confirmation');
                  } else {
                    p.infosModal('warning',response.data.error,false,this.$i18n.t('Champs incomplets'));
                  }
                }
                p.loading = false;
              }).catch(function(error){
                p.loading = false;
              });
            }
        },
        ajouter_plage(f){
            if(f.ajouter_plage.de.prefixe==f.ajouter_plage.a.prefixe && f.ajouter_plage.de.section==f.ajouter_plage.a.section){
              if(f.ref_cad[0].section=='')f.ref_cad.splice(0,1);
              for(var i=f.ajouter_plage.de.parcelle;i<=f.ajouter_plage.a.parcelle;i++){
                f.ref_cad.push({prefixe:f.ajouter_plage.de.prefixe,section:f.ajouter_plage.de.section,parcelle:i});
              }
              f.ajouter_plage=0;
            }else{
              alert(this.$i18n.t("Attention la section de début et de fin doit être la même"));
            }
            this.cpc;
        },
        addDataCPN(group,f) {
          f.ci_naissance=group.selectedObject.CODE_INSEE;
          f.cp_naissance=group.selectedObject.CODE_POSTAL;
          f.ville_naissance=group.selectedObject.LABEL;
          this.cpc();
        },
        addDataCP(group,f) {
          f.code_insee=group.selectedObject.CODE_INSEE;
          f.code_postal=group.selectedObject.CODE_POSTAL;
          f.ville=group.selectedObject.LABEL;
          this.cpc();
        },
        addDataSIREN(group,f) {
          f.siren=group.selectedObject.siret.substr(0,9);
          f.denomination=group.selectedObject.name;
          f.categorie_juridique=group.selectedObject.categorie_juridique;
          f.adresse=group.selectedObject.address1;
          f.code_postal=group.selectedObject.cp;
          f.ville=group.selectedObject.ville;
          f.ville_rcs=group.selectedObject.villercs;
          f.code_postal_rcs=group.selectedObject.cprcs;
          if(group.selectedObject.pays)f.pays=group.selectedObject.pays;
          this.cpc();
        },
        change_pays_naissance(f){
          f.ci_naissance=f.pays_naissance;
          f.cp_naissance=f.pays_naissance;
          if(f.pays_naissance==99100){
            f.ci_naissance="";
            f.cp_naissance="";
          }
        },
        resetcp(f){
          if(f.pays_naissance==='99100'){f.ci_naissance='';f.cp_naissance='';f.ville_naissance='';}
        },
        alertEF(){
          alert(this.$i18n.t('Merci de remplir tous les champs obligatoire.'));
        },
      }
  }
</script>